// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-n-id] rect {
    /* height:180px;
    width:300px; */
    cursor: pointer;
}

form{
height: 300px !important;
position: absolute !important;
top: 20% !important;
right:1% !important
}

.boc-input{
    color:#a39f9f !important;
    font-weight:600 !important; 
    margin-left: -12px;
}
.boc-input input{
    color:#a39f9f !important;
    font-weight:600 !important; 
   
}
.boc-edit-form-header{
    display: none;
}
.boc-edit-form-instruments{
    display:none
}
.boc-form-fieldset{
    display:none
}
.boc-edit-form-fields{
    padding:10px 5px;
    flex-grow: unset !important;
    overflow: hidden !important;
}

.ant-select-dropdown{
    z-index: 999999 !important;
    outline: none !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/balkan.css"],"names":[],"mappings":"AAAA;IACI;kBACc;IACd,eAAe;AACnB;;AAEA;AACA,wBAAwB;AACxB,6BAA6B;AAC7B,mBAAmB;AACnB;AACA;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,0BAA0B;;AAE9B;AACA;IACI,aAAa;AACjB;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B","sourcesContent":["[data-n-id] rect {\r\n    /* height:180px;\r\n    width:300px; */\r\n    cursor: pointer;\r\n}\r\n\r\nform{\r\nheight: 300px !important;\r\nposition: absolute !important;\r\ntop: 20% !important;\r\nright:1% !important\r\n}\r\n\r\n.boc-input{\r\n    color:#a39f9f !important;\r\n    font-weight:600 !important; \r\n    margin-left: -12px;\r\n}\r\n.boc-input input{\r\n    color:#a39f9f !important;\r\n    font-weight:600 !important; \r\n   \r\n}\r\n.boc-edit-form-header{\r\n    display: none;\r\n}\r\n.boc-edit-form-instruments{\r\n    display:none\r\n}\r\n.boc-form-fieldset{\r\n    display:none\r\n}\r\n.boc-edit-form-fields{\r\n    padding:10px 5px;\r\n    flex-grow: unset !important;\r\n    overflow: hidden !important;\r\n}\r\n\r\n.ant-select-dropdown{\r\n    z-index: 999999 !important;\r\n    outline: none !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
